import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'
import { WeveButtonIcon } from '@weve/ui'

import { TrashIcon } from '@icons'

export default Vue.extend({
  name: 'WeveButtonDelete',
  functional: true,
  render(h, { data }) {
    return h(
      WeveButtonIcon,
      mergeData(data, {
        props: { label: 'Delete', color: 'danger' },
      }),
      [h(TrashIcon)]
    )
  },
})
